import React from "react";
import {useTranslation} from "react-i18next";
import {BarReportWidget} from "../BarReportWidget/BarReportWidget";

export const HourlyOrderStatsWidget = ({data = [], loading}) => {
    const {t} = useTranslation(["hourlyOrderStatsWidget"]);
    function pad(num) {
        num = num.toString();
        while (num.length < 2) num = "0" + num;
        return num;
    }

    const resolver = hourlyStatsArr =>
        hourlyStatsArr.map((avgHourlyDelivered, i) => ({
            name: `${pad(i)}:00`,
            value: avgHourlyDelivered
        }));
    return (
        <BarReportWidget
            barColor={"#72ECA5"}
            data={resolver(data)}
            height={200}
            loading={loading}
            title={<h1>{t("hourlyOrderTitle", {ns: "hourlyOrderStatsWidget"})}</h1>}
        />
    );
};

export const dummyHourlyOrderStats = [
    {
        name: "00.00 - 01.00",
        value: 240
    },
    {
        name: "01.00 - 02.00",
        value: 200
    },
    {
        name: "02.00 - 03.00",
        value: 100
    },
    {
        name: "03.00 - 04.00",
        value: 10
    },
    {
        name: "04.00 - 05.00",
        value: 5
    },
    {
        name: "05.00 - 06.00",
        value: 50
    },
    {
        name: "06.00 - 07.00",
        value: 100
    },
    {
        name: "07.00 - 08.00",
        value: 90
    },
    {
        name: "08.00 - 09.00",
        value: 200
    },
    {
        name: "10.00 - 11.00",
        value: 500
    },
    {
        name: "11.00 - 12.00",
        value: 700
    },
    {
        name: "12.00 - 13.00",
        value: 850
    },
    {
        name: "13.00 - 14.00",
        value: 950
    },
    {
        name: "14.00 - 15.00",
        value: 1000
    },
    {
        name: "15.00 - 16.00",
        value: 980
    },
    {
        name: "16.00 - 17.00",
        value: 950
    },
    {
        name: "17.00 - 18.00",
        value: 700
    },
    {
        name: "18.00 - 19.00",
        value: 650
    },
    {
        name: "19.00 - 20.00",
        value: 500
    },
    {
        name: "20.00 - 21.00",
        value: 500
    },
    {
        name: "21.00 - 22.00",
        value: 350
    },
    {
        name: "22.00 - 23.00",
        value: 250
    },
    {
        name: "23.00 - 00.00",
        value: 150
    }
];
